import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const  tipoAutorizzazione: AnaColumn[] = [
    {
      itemType: "group", colCount: "1", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "Codice", width: "40", hideOnEdit: true },
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione", maxSize: 255, maxLength: '255', width: 25.5 * aspect },
        { type: 'campo', colVisible: false, dataField: "versione", hideOnEdit: true, dataType: "" },
        { type: 'campo', colVisible: false, dataField: "nomeTabella", dataType: "", hideOnEdit: true, disableOnUpdate: true },
      ]
    },
  ]